import QuoteReducer from './quoteReducer'
import { combineReducers } from 'redux'
import FinanReducer from './FinanReducer'
import weekTReducer from './weekTReducer'
import monthTReducer from './monthTReducer'
import dayTReducer from './dayTReducer'
import IndicatorApi_Reducer from './IndicatorApi_Reduceri'
 
const rootReducer = combineReducers({
   Quote: QuoteReducer,
   Fs: FinanReducer,
   Week: weekTReducer,
   Month: monthTReducer,
   Daily: dayTReducer,
   Indicate: IndicatorApi_Reducer,
 })

export default rootReducer
